import { SimpleTextField } from "solveiq.designsystem";
import { withStyles } from "@material-ui/core/styles";

// Dave's component with Raul's design to be align with the Cart style
export default withStyles({
  root: {
    "& label.Mui-focused": {
      color: "#0FB4D1",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderWidth: 2,
      },
      "& input:valid:hover + fieldset": {
        borderColor: "#0FB4D1",
      },
      "& input:valid:focus + fieldset": {
        borderColor: "#0FB4D1",
      },
    },
  },
})(SimpleTextField);
